const projectColors = {
  primary: {
    main: "#0B2845",
    light: "#18508C",
    dark: "#061423",
    contrastText: "#fff",
  },
  secondary: {
    main: "#450B28",
    light: "#8c1717",
    dark: "#230606",
    contrastText: "#fff",
  },
};

export default projectColors;
